import { reportAppUrlEnd, reportAppUrlStart } from '../bi/bi';
import { useNewWindowHandlers } from '../context/NewWindowHandlersContext';
export const useOauthBroadcastRedirectHandler = () => {
  const {
    showProgressBar,
    broadcastChannel,
    updateWindowSrcWithUrl
  } = useNewWindowHandlers();
  return (resolve, appUri) => {
    const handleFirstRedirect = event => {
      const redirectUrl = event.data.redirectUrl;
      if (event.data.type === 'receivedRedirectUrl' && redirectUrl) {
        const state = event.data.state === 'undefined' ? undefined : event.data.state;
        showProgressBar();
        reportAppUrlEnd({
          url: appUri
        });
        resolve({
          redirectUrlAnswerFromTpa: redirectUrl,
          oauth2State: state
        });
      } else {
        resolve({});
      }
    };
    broadcastChannel.onmessage = handleFirstRedirect;
    updateWindowSrcWithUrl(appUri);
    reportAppUrlStart({
      url: appUri
    });
  };
};
//# sourceMappingURL=useOauthBroadcastRedirectHandler.js.map